import { render, staticRenderFns } from "./ArticleHeadMenu.vue?vue&type=template&id=392f0658&scoped=true&"
import script from "./ArticleHeadMenu.vue?vue&type=script&lang=js&"
export * from "./ArticleHeadMenu.vue?vue&type=script&lang=js&"
import style0 from "./ArticleHeadMenu.vue?vue&type=style&index=0&id=392f0658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f0658",
  null
  
)

export default component.exports